/**
 * Transforms a string to lowercase.
 *
 * @param {String} value
 *
 * @return {String}
 */
export const lowercase = (value: string | null): string =>
  value ? value.toLowerCase() : '';
